import React from 'react'
import cx from 'classnames'
import styles from './ContactsTable.module.scss'

interface StatusProps {
  label: string
  isActive: boolean
}

const Status = ({ label, isActive }: StatusProps) => (
  <span className={cx(styles.status, { [styles['status-inactive']]: !isActive })}>
    <span className={styles['status-dot']} aria-hidden="true" />
    {label}
  </span>
)

export default Status
